class APIS {
	apis() {
		return {
			listing: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/conversation/aht'
			},
			serviceLevel: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/service/level'
			},
			agentAvgTime: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ticket/agent/response'
			},
		};
	}
}

export default new APIS();
